import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Accordion from '@material-ui/core/Accordion'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Timeline from '@material-ui/lab/Timeline'
import TimelineItem from '@material-ui/lab/TimelineItem'
import TimelineSeparator from '@material-ui/lab/TimelineSeparator'
import TimelineConnector from '@material-ui/lab/TimelineConnector'
import TimelineContent from '@material-ui/lab/TimelineContent'
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent'
import TimelineDot from '@material-ui/lab/TimelineDot'
import Typography from '@material-ui/core/Typography'
import moment from 'moment'
import { Pagination } from '@material-ui/lab'

import { CardDate, Loading } from 'components'
import noData from 'assets/images/no-data.svg'
import { useUser } from 'context/user/user.context'

import { translate } from 'locales'
import { findAllMedicalRecordsPsico } from './services'

import * as S from './styles'
import * as N from '../New/styles'
import TimeLineResumeNutritionist from './TimeLineResumeNutritionist'

moment.locale('pt-br', {
  monthsShort: [
    'Jan',
    'Fev',
    'Mar',
    'Abr',
    'Mai',
    'Jun',
    'Jul',
    'Ago',
    'Set',
    'Out',
    'Nov',
    'Dez',
  ],
})

const useStyles = makeStyles((theme: any) => ({
  timeline: {
    padding: 0,
  },
  left: {
    flex: 'none',
    paddingLeft: 0,
  },
  right: {
    paddingRight: 0,
  },
  secondaryTail: {
    backgroundColor: theme.palette.secondary.main,
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
    '@media(max-width: 740px)': {
      flexDirection: 'column',
      gap: '10px',
    },
  },
}))

interface IResume {
  userUUID: string
}

const Nutri: React.FunctionComponent<IResume> = ({ userUUID }) => {
  const classes = useStyles()
  const { userData } = useUser()

  const [records, setRecords] = useState<any>({})
  const [loading, setLoading] = useState(true)

  const [totalPages, setTotalPages] = useState(0)
  const [page, setPage] = useState(1)

  useEffect(() => {
    const specialties = userData?.specialties

    const specialty =
      specialties &&
      specialties.filter((item: any) => item?.slug === 'nutricionista')[0]

    if (specialty) {
      findAllMedicalRecordsPsico(
        userUUID,
        specialty.id,
        setRecords,
        setLoading,
        page,
        setTotalPages
      )
    }
  }, [userData, page])

  return (
    <>
      {loading && <Loading title={translate('medicalRecord.loadingData')} />}
      <Timeline align="left" className={classes.timeline}>
        {records.medicalRecordsPsico &&
          Object.keys(records.medicalRecordsPsico).length === 0 && (
            <N.NoData>
              <img
                src={noData}
                alt="Icone simbolizando que não existe prontuarios a serem exibidas"
              />
              <span>{translate('medicalRecord.notMedicalRecord')}</span>
            </N.NoData>
          )}

        {records.medicalRecordsPsico &&
          Object.keys(records.medicalRecordsPsico).map((item) => (
            <TimelineItem key={item}>
              <TimelineOppositeContent className={classes.left}>
                <CardDate
                  day={moment.utc(item).format('DD')}
                  month={moment.utc(item).format('MMM')}
                  year={moment.utc(item).format('YYYY')}
                />
              </TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineDot />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent className={classes.right}>
                {records.medicalRecordsPsico[item].map((i: any) => (
                  <Accordion key={i.id}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id={i.id}
                    >
                      <div
                        className={classes.heading}
                        style={{
                          marginTop: 0,
                          display: 'flex',
                          flex: 1,
                          justifyContent: 'space-between',
                        }}
                      >
                        <Typography>
                          {`${translate('medicalRecord.by')} Dr(a). ${
                            i.scheduling?.doctor?.name
                          }`}

                          <Typography>
                            {`${translate('schedule.scheduleDate')}: ${moment(
                              i.scheduling.from_date_time
                            ).format('DD/MM/YYYY')}`}
                          </Typography>
                        </Typography>
                      </div>
                      <div>
                        <Typography>
                          {`(${i.scheduling?.specialty_name})`}
                        </Typography>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails style={{ display: 'block', padding: 0 }}>
                      <TimeLineResumeNutritionist
                        history={i}
                        records={records}
                        setLoading={setLoading}
                        setRecords={setRecords}
                      />
                    </AccordionDetails>
                  </Accordion>
                ))}
              </TimelineContent>
            </TimelineItem>
          ))}
        <S.ContentPagination>
          {totalPages > 1 && (
            <Pagination
              count={totalPages}
              onChange={(event: React.ChangeEvent<unknown>, value: number) => {
                setPage(value)
              }}
            />
          )}
        </S.ContentPagination>
      </Timeline>
    </>
  )
}

export default Nutri
